import script from "./resultDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./resultDetails.vue?vue&type=script&setup=true&lang=js"

import "./resultDetails.vue?vue&type=style&index=0&id=4e12bd27&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e12bd27"]])

export default __exports__